import React from "react";
import { makeStyles, SvgIcon } from '@material-ui/core';
import { Row, Container, Col } from 'react-bootstrap';
import NotApproved from '../icons/notApproved.svg';
import './Ineligible.scss';
import IconHolder from "../../../Helpers/IconHolder";
import phoneCall from '../../../../icons/phoneCall.svg';
import { useHistory } from "react-router-dom";
import CustomerSupportPhone from "../../../Account/CustomerSupportPhone";
import SvgComponent from "../../../Helpers/Svg/SvgIcon";

export default function Ineligible({ ineligibleProducts }) {
  const history = useHistory();

  const useStyles = makeStyles(theme => ({
    primaryColor: {
      color: theme.palette.primary.main,
    },
    primaryLink: {
      color: theme.palette.primary.main,
       '&:hover': {
         color: theme.palette.primary.main,
       },
       '&:focus': {
         color: theme.palette.primary.main,
       },
    },
    PromotedProductBackgroundImage: {
      backgroundImage: (props) => (props.backgroundImage ? `url(${props.backgroundImage})` : "url(/Tools/perm_banner.jpg)"),
    },
    PromotedProductBackgroundColor: {
      backgroundColor: `${theme.palette.primary.main}16`,
    },
  }));

  const handleRedirect = (ctaType, redirectPath) => {
    if (ctaType === "redirect" && redirectPath) {
      history.push(redirectPath);
    }
  };

  const classes = (props) => useStyles(props);

  const ineligibleInfo = [
    {
      text: "We’re sorry, Americo was unable to approve your application request."
    },
    {
      text: "Don’t worry, we can help you find the right insurance coverage at the right price."
    },
    {
      text: "For an even more personalized experience, contact our team of insurance specialists."
    }
  ];

  return (
    <Container className="ineligible-div">
      <Row className="justify-content-center mb-3">
        <IconHolder icon={NotApproved} viewBox="0 0 25 25" />
      </Row>
      <Row className="justify-content-center">
        <h4 className="header-title mb-3">Thank you for your interest.</h4>
      </Row>
      {ineligibleInfo.map((data, i) => 
        <Row className="justify-content-center" key={i}>
          <Col lg={4} md={6} sm={8} xs={9} className="sub-text-div">
            <h4 className="sub-text sub-header">{data.text}</h4>
          </Col>
        </Row>
      )}
      <Row className='mt-2 d-flex justify-content-center align-items-center'>
        <SvgIcon component={phoneCall} color="primary" className='mr-1' fontSize="small"/><b>
          <a href={`tel:${CustomerSupportPhone()}`} className={`${classes().primaryLink} ml-1 sub-header`}>{CustomerSupportPhone()}</a></b>
      </Row>
      <div className="header-card mt-4">
        {ineligibleProducts && ineligibleProducts.map((data, i) => {
          return (
            <Row className={`${i === 0 ? 'mt-2' : 'promoted-products-div'} justify-content-center`} key={i}>
              <Col lg={6} md={8} sm={10} className="promoted-products-sub-div">
                <button
                  className={`promoted-product ${data.hasBackgroundImage ? `${classes({backgroundImage: data.backgroundImage}).PromotedProductBackgroundImage } has-bg-image` : classes().PromotedProductBackgroundColor}`}
                  onClick={() => handleRedirect(data.ctaType, data.redirectUri)}>
                  <div className={`content-group`}>
                    <div className={`icon-container`}>
                      <SvgComponent iconName={data.icon} className={data.hasBackgroundImage ? 'white-text' : classes().primaryColor} />
                    </div>
                    <h3>{data.title}</h3>
                    <p>{data.subTitle}</p>
                  </div>
                  <span className={classes().primaryColor}>{data.buttonText}</span>
                </button>
              </Col>
            </Row>
          );
        })}
      </div>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/Ineligible.js